const initState = {
    getAll: {
        data: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    }
};

export default initState;